const PropTypes = require('prop-types');
const React = require('react');

class ProductSpecsList extends React.Component {
  renderSpecRow(spec, idx) {
    if (!spec || !spec.value) { return null; }

    return ([
      <dt>{spec.name}</dt>,
      <dd>
        {spec.value.path ?
          <a href={spec.value.path}>{spec.value.name}</a>
          : spec.value.name
        }
      </dd>
    ])
  }

  render() {
    return (
      <section>
        <h3 className="size-120 mtb-2">{I18n.t('comparisonShoppingPage.productSpecs')}</h3>
        <dl className="description-section__spec-list">
          {this.props.productSpecs.map((spec, idx) => (
            this.renderSpecRow(spec, idx)
          ))}
        </dl>
      </section>
    )
  }
}

ProductSpecsList.propTypes = {
  productSpecs: PropTypes.array.isRequired,
}

module.exports = ProductSpecsList;



// WEBPACK FOOTER //
// ./javascripts/components/comparison_shopping_page/product_specs_list.jsx